import React from 'react'
import Products from '../components/Products/Product'
const ProductsPage = () => {
  return (
<Products></Products>
  )
}

export default ProductsPage